// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavbarComponent from './components/NavbarComponent';
import YouTubeFeed from './components/Videos';
import AboutUs from './components/AboutUs';
import Topics from './components/Topics';
import ContactForm from './components/ContactForm';
import FooterComponent from './components/FooterComponent';
import logo from './media/logo.PNG';
import './styles/App.css';

function HomePage() {
  return (
    <div className="App">
      <header className="App-header">
        <h1 style={{ fontFamily: 'Cinzel', fontWeight: '600', fontSize: '50px' }}>Why God Ministries</h1>
        <img src={logo} className="App-logo" alt="logo" />
        <h3 style={{ textDecoration: 'italic', fontSize: '20px', fontFamily: 'Cinzel'}}>Evidence God is Real and The Bible is True</h3>
      </header>
        <h1 style={{ fontFamily: 'Cinzel', marginTop: 70, fontWeight: '600', fontSize: '50px' }}>Featured</h1>
        <div style={{ marginTop: 40, width: '100%', maxWidth: '1000px', marginLeft: 'auto', marginRight: 'auto' }}>
          <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)' }}>
            <iframe
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
              src="https://www.youtube.com/embed/C4TrSG_kMwY?si=I8tbgz6vkZoy5Tpp"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      <YouTubeFeed />
    </div>
  );
}

function App() {
  return (
    <Router>
      <NavbarComponent />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/videos" element={<YouTubeFeed />} />
        {/* <Route path="/topics" element={<Topics />} /> */}
        <Route path="/contact" element={<ContactForm />} />
      </Routes>
          <FooterComponent />
    </Router>
  );
}

export default App;
